/**
 * Badge — etiqueta de estado/categoria.
 *
 * `light` = variante outline translúcida (fundo 22% alpha, borda 55% alpha).
 * `color` = qualquer cor HEX da paleta C; default = C.cyber.
 * Visual Sphere: raio 7, texto ≥ 11 px; o estado vem sempre escrito (nunca só cor).
 */
import { C } from '@/theme/palette';

export function Badge({ children, color = C.cyber, light = false }) {
  return (
    <span
      style={{
        color: light ? color : C.black,
        backgroundColor: light ? `${color}22` : color,
        border: light ? `1px solid ${color}55` : `1px solid ${color}`,
        fontSize: 11,
        fontWeight: 600,
        lineHeight: 1.45,
        padding: '2px 8px',
        borderRadius: 7,
        letterSpacing: '0.03em',
        textTransform: 'uppercase',
        display: 'inline-block',
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </span>
  );
}
